module.exports = __webpack_public_path__ + "static/media/azure.2a2fc2b1.png";